<template>
  <div id="contenedor-catalogo-etiquetas-main">
    <v-toolbar flat>
      <v-toolbar-title> </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        rounded
        small
        class="text-capitalize"
        @click="mostrarAgregarEtiqueta = true"
      >
        <v-icon left small>
          mdi-plus
        </v-icon>
        Agregar etiqueta
      </v-btn>
    </v-toolbar>
    <v-skeleton-loader
      v-if="$apollo.loading"
      type="list-item-avatar,list-item-avatar,list-item-avatar"
    ></v-skeleton-loader>
    <template v-else>
      <v-alert
        v-if="getCatalogoAuditoriaEtiquetas.length < 1"
        color="info"
        align="center"
        dark>
        No hay etiquetas registradas.
      </v-alert>
      <v-simple-table v-else>
        <template>
          <thead>
            <tr>
              <th class="text-left">Etiqueta</th>
              <th class="text-right">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="etiqueta in getCatalogoAuditoriaEtiquetas">
              <template>
                <tr :key="etiqueta.id">
                  <td align="left">
                    <v-chip :dark="etiqueta.esTextoClaro" :color="etiqueta.color">
                      {{ etiqueta.descripcion }}
                    </v-chip>
                  </td>
                  <td align="right">
                    <v-btn icon @click="editarEtiqueta(etiqueta)">
                      <v-icon>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                    <v-btn icon @click="eliminarEtiqueta(etiqueta)">
                      <v-icon>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <v-dialog v-if="mostrarAgregarEtiqueta" v-model="mostrarAgregarEtiqueta" width="500">
      <AgregarAuditoriaEtiqueta v-on:cerrar="cerrarVentana" />
    </v-dialog>
    <v-dialog v-if="estaEtiqueta" v-model="mostrarEditarEtiqueta" width="500">
      <EditarAuditoriaEtiqueta
        :catalogoAuditoriaEtiquetaEditar="estaEtiqueta"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
    <v-dialog v-if="estaEtiqueta" v-model="mostrarEliminarEtiqueta" width="500">
      <EliminarAuditoriaEtiqueta
        :catalogoAuditoriaEtiquetaEliminar="estaEtiqueta"
        v-on:cerrar="cerrarVentana"
      />
    </v-dialog>
  </div>
</template>

<script>
import CATALOGO_AUDITORIA_ETIQUETAS from '@/graphql/querys/administracion/auditorias/catalogo-etiquetas/catalogoAuditoriaEtiquetas.gql';
import AgregarAuditoriaEtiqueta from '@/components/administracion/auditorias/catalogo-etiquetas/Agregar.vue';
import EditarAuditoriaEtiqueta from '@/components/administracion/auditorias/catalogo-etiquetas/Editar.vue';
import EliminarAuditoriaEtiqueta from '@/components/administracion/auditorias/catalogo-etiquetas/Eliminar.vue';

export default {
  name: 'CatalogoEtiquetasMain',
  components: {
    AgregarAuditoriaEtiqueta,
    EditarAuditoriaEtiqueta,
    EliminarAuditoriaEtiqueta,
  },
  data() {
    return {
      mostrarAgregarEtiqueta: false,
      mostrarEditarEtiqueta: false,
      mostrarEliminarEtiqueta: false,
      estaEtiqueta: null,
    };
  },
  apollo: {
    catalogoAuditoriaEtiquetas: {
      query: CATALOGO_AUDITORIA_ETIQUETAS,
    },
  },
  methods: {
    editarEtiqueta(etiqueta) {
      this.estaEtiqueta = etiqueta;
      this.mostrarEditarEtiqueta = true;
    },
    eliminarEtiqueta(etiqueta) {
      this.estaEtiqueta = etiqueta;
      this.mostrarEliminarEtiqueta = true;
    },
    cerrarVentana() {
      this.mostrarAgregarEtiqueta = false;
      this.mostrarEditarEtiqueta = false;
      this.mostrarEliminarEtiqueta = false;
      this.estaEtiqueta = null;
    },
  },
  computed: {
    getCatalogoAuditoriaEtiquetas() {
      if (!this.catalogoAuditoriaEtiquetas) return [];
      return this.catalogoAuditoriaEtiquetas;
    },
  },
};
</script>

<style lang="scss" scoped></style>
